import { PropTypes } from 'prop-types';
import { MdChevronRight } from 'react-icons/md';
const AccommodationMenuList = ({ items, activeTab, handleTabClick }) => {
    return (
        <div>
            <div className="flex w-full items-center justify-center ">
                <div className="flex flex-col  gap-5  w-full" role="tablist">
                    {items?.map((item, index) => (

                        item?.subItems ? (
                            <>
                                <div
                                    key={index}
                                    className={`w-full  p-4 `}
                                    role="presentation"
                                >
                                    <button
                                        className={`flex items-center w-full text-start justify-between  ${item.subItems.find(i => i.index === activeTab) ? "text-blue-700" : "text-sky-950"}  text-2xl font-bold `}
                                    >


                                        {item?.title}
                                        <span className='w-4 '>
                                            <MdChevronRight size={25} />
                                        </span>
                                    </button>
                                </div>
                                {item?.subItems?.map((subItem, subIndex) => (
                                    <div
                                        key={subIndex}
                                        className={`w-full p-4  ${subIndex === item?.subItems?.length-1 && "border-b border-dashed border-sky-950 border-opacity-20"} ${subItem.index === activeTab ? "bg-slate-50 rounded " : "bg-transparent"} `}
                                        role="presentation"
                                    >
                                        <button
                                            className={`flex 2xl:pl-10 items-center w-full  justify-between  ${subItem?.index === activeTab ? "text-blue-700" : "text-sky-950"}  text-2xl font-bold `}
                                            onClick={() => handleTabClick(subItem?.index)}
                                        >
                                            <div className='flex  self-start items-center gap-4'>
                                                
                                                    <div className={`w-4 h-4 rounded-full bg-blue-700 ${subItem?.index === activeTab ? "visible" : "invisible"}`} />
                                                
                                                {subItem?.name}
                                            </div>
                                            <span className='w-4 '>
                                                <MdChevronRight size={25} />
                                            </span>
                                        </button>
                                    </div>
                                )
                                )
                                }
                            </>
                        )
                            :
                            <div
                                key={item.index}
                                className={`w-full p-4 border-b border-dashed border-sky-950 border-opacity-20 ${item.index === activeTab ? "bg-slate-50 rounded " : "bg-transparent"} `}
                                role="presentation"
                            >
                                <button
                                    className={`flex items-center w-full text-start justify-between  ${item?.index === activeTab ? "text-blue-700" : "text-sky-950"}  text-2xl font-bold `}
                                    onClick={() => handleTabClick(item?.index)}
                                >
                                    {item?.title}
                                    <span className='w-4 '>
                                        <MdChevronRight size={25} />
                                    </span>
                                </button>
                            </div>

                    ))}
                </div>
            </div>
        </div>
    )
}
AccommodationMenuList.propTypes = {
    items: PropTypes.array,
    activeTab: PropTypes.number,
    handleTabClick: PropTypes.func,
}
export default AccommodationMenuList